import React from 'react';
import { useNavigate } from 'react-router-dom';
import { styled } from '@mui/system';
import ShoppingCart from '../../assets/shopping-cart.png'
import { routingPath } from '../../utils/path';

const CartButtonWrapper = styled('div')({
  position: 'sticky', // 固定表示
  bottom: 16,
  right: 16,
  zIndex: 1,
  width: '212px',
  height: '56px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundImage: `url(${ShoppingCart})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  cursor: 'pointer',
  marginLeft: 'auto',
});

const CartButtonText = styled('span')({
  color: 'white',
  fontWeight: 'bold',
  fontSize: '16px',
  marginLeft: '10px'
});


const CartButton = () => {
  const navigate = useNavigate();

  return(
    <CartButtonWrapper aria-label="cart" onClick={() => navigate(routingPath.auth.cart)}>
      <CartButtonText>カートをみる</CartButtonText>
    </CartButtonWrapper>
  );
};

export default CartButton;
